const initialFilters = {
    searchFilters: {},
    pagination: {
        currentPage: 1,
        pageSize: 10,
    },
    refreshIndex: 0
};


export const initialState = {
    items: [],
    totalCount: 0,
    selectedQV: null,
    filters: initialFilters,
    isLoading: false,
    indexVisibility: 0,
    elm: '',
};


export const reducer = (state, action) => {
    switch (action.type) {
        case "set_loading":
            return { ...state, isLoading: action.payload };
        case "set_index_visibility":
            return { ...state, indexVisibility: action.payload };
        case "set_items":
            return { ...state, items: action.payload.items, totalCount: action.payload.count };
        case "set_search_filters":
            return { ...state, filters: { ...state.filters, searchFilters: action.payload } };
        case "refresh_list":
            return { ...state, filters: { ...state.filters, refreshIndex: state.filters.refreshIndex + 1 } };
        case "set_table_pagination":
            return { ...state, filters: { ...state.filters, pagination: action.payload } }
        case "open_view":
            return { ...state, selectedQV: action.payload.qv, indexVisibility: action.payload.index };
        default:
            return state;
    }
};